/* eslint-disable @next/next/no-img-element */
import { isArray, isObject, isEmpty, toNumber } from 'lodash';

export default function SlideImage({ articleInformation }) {
    const NUMBER_TYPE_LIST = ['budget_raw', 'budget_finishing', 'area_width', 'area_length', 'area_real', 'area_total', 'year'];
    const ARTICLE_INFO = {
        house_name: {
            position: 1,
            name: 'Tên ngôi nhà'
        },
        budget_raw: {
            position: 2,
            name: 'Ngân sách xây thô',
            unit: ' đồng',
            type: 'number'
        },
        budget_finishing: {
            position: 2,
            name: 'Ngân sách hoàn thiện',
            unit: ' đồng',
            type: 'number'
        },
        area: {
            position: 3,
            name: 'Kích thước',
            child: { area_width: 'm ngang', area_length: 'm dọc' },
            type: 'number'
        },
        area_real: {
            position: 4,
            name: 'Diện tích mặt bằng',
            unit: 'm2',
            type: 'number'
        },
        area_total: {
            position: 4,
            name: 'Tổng diện tích',
            unit: 'm2',
            type: 'number'
        },
        year: {
            position: 5,
            name: 'Năm hoàn thành',
            type: 'number'
        },
        designer: {
            position: 6,
            name: 'Thiết kế',
        },
        constructorApi: {
            position: 7,
            name: 'Thi công',
        },
        photographer: {
            position: 8,
            name: 'Chụp ảnh',
        }
    };

    const information = {};
    let listOfInfo = [];

    if (isArray(articleInformation)) {
        listOfInfo = articleInformation;
    }

    if (!isArray(articleInformation) && isObject(articleInformation)) {
        listOfInfo = Object.values(articleInformation);
    }

    listOfInfo.forEach(info => {
        const infoHouse = Object.entries(info)[0];
        if (infoHouse[0] == 'constructor') infoHouse[0] = 'constructorApi';
        if (infoHouse[1] && infoHouse[1] != "undefined" && infoHouse[1] != "null" && (infoHouse[1] !== 0)) {
            information[infoHouse[0]] = infoHouse[1];
        }
    });

    const isDisplay = !isEmpty(Object.keys(information).filter(x => x != 'link_360'));

    return <>
        {isDisplay &&
            <div className="listDetail">
                <div className="listDetail-info">
                    <ul>
                        {
                            Object.keys(ARTICLE_INFO).map((infoKey, index) => {
                                if (ARTICLE_INFO[infoKey].child) {
                                    const child = ARTICLE_INFO[infoKey].child;
                                    if (!Object.keys(child).some(x => information[x])) {
                                        return <></>;
                                    }

                                    return <li key={infoKey + index}>
                                        <div className="title">{ARTICLE_INFO[infoKey].name}</div>
                                        <div className="text">
                                            {Object.keys(child).map(childKey => ((information[childKey]) &&
                                                // eslint-disable-next-line react/jsx-key
                                                <span>{information[childKey]}{child[childKey]}</span>
                                            ))
                                            }
                                        </div>
                                    </li>;
                                }

                                if (!information[infoKey]) return <></>;
                                return <li key={infoKey + index}>
                                    <div className="title">{ARTICLE_INFO[infoKey].name}</div>
                                    <div className="text">{information[infoKey]}{ARTICLE_INFO[infoKey].unit}</div>
                                </li>;
                            })
                        }
                    </ul>
                </div>
            </div>
        }
    </>;
};